import { useMediaQuery, useTheme } from '@mui/material';
import React, { memo } from 'react';
import { IFilterBaseProps } from '~/Components/Filter';
import { PopoverToModal } from '~/Components/PopoverToModal';
import { VERTICAL_SEPARATOR } from '~/Constants/Colors.constants';
import { FONT_SIZE_MEDIUM_CONFUSED } from '~/Constants/UI.constants';
import { useLanguage } from '~/Hooks';
import { Button, Typography } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';

export interface IFilterModal extends IFilterBaseProps {
  anchorEl: Element | null | undefined;
  selectedCount: number;
}

const useStyles = makeStyles({
  content: {
    height: '100%',
    display: 'grid',
    alignContent: 'space-between',
    '&>.root': {
      padding: '8px 0',
    },
  },
  footer: {
    padding: '10px 16px',
    borderTop: `1px solid ${VERTICAL_SEPARATOR}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    padding: '26px 18px 11px 24px',
    fontSize: FONT_SIZE_MEDIUM_CONFUSED,
  },
});

export const FilterModal = memo(
  ({ anchorEl, children, open, onClear, onClose, onApply, selectedCount }: IFilterModal) => {
    const { t } = useLanguage();
    const { classes } = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
      <PopoverToModal
        onActionTaken={onClear}
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        title={t('app.filter')}
        actionName={t('app.filter.clear')}
        cancelInsteadOfBack
        width={300}
      >
        <div className={classes.content}>
          {!isMobile && (
            <Typography variant="h4" className={classes.title}>
              {t('app.filter')}
            </Typography>
          )}
          {children}
          <div className={classes.footer}>
            {isMobile && (
              <Typography
                variant="body2"
                dangerouslySetInnerHTML={{
                  __html: t('app.filter.selectedCount', { count: selectedCount }),
                }}
              />
            )}
            {!isMobile && (
              <Button size="medium" onClick={onClear} variant="outlined">
                {t('app.filter.clear')}
              </Button>
            )}
            <Button size="medium" onClick={onApply} variant="contained">
              {t('app.filter.apply')}
            </Button>
          </div>
        </div>
      </PopoverToModal>
    );
  },
);
